import { render } from "./FeeConflict.vue?vue&type=template&id=152a1248"
import script from "./FeeConflict.vue?vue&type=script&lang=js"
export * from "./FeeConflict.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__